import type { Extensions } from '@tableau/extensions-api-types';
import tableauApi from 'tableau-extensions-api';

interface TableauGlobal {
  extensions: Extensions;
  TableauEventType: {
    MarkSelectionChanged: string;
    FilterChanged: string;
    ParameterChanged: string;
  };
}

export interface TableauEnvironment {
  userId: string | null;
  workbookName: string | null;
  dashboardName: string | null;
  isMock: boolean;
}

export async function initializeExtension(): Promise<TableauEnvironment> {
  try {
    await tableauApi.extensions.initializeAsync();
  } catch (err) {
    throw new Error(
      `Tableau extension initialization failed: ${err instanceof Error ? err.message : String(err)}`
    );
  }

  const env = tableauApi.extensions.environment;
  const dashboard = tableauApi.extensions.dashboardContent?.dashboard;

  // Note: The Extensions API doesn't directly expose workbook name.
  // The workbook name can be configured via extension settings if needed.
  return {
    userId: env?.uniqueUserId ?? null,
    workbookName: null,
    dashboardName: dashboard?.name ?? null,
    isMock: false,
  };
}

export function getTableau(): TableauGlobal {
  return tableauApi as TableauGlobal;
}
